import React from "react";

import PriceIgv from "components/Tvendo/Article/DataMaster/PriceIgv/List";

export default function () {
  return <PriceIgv />;
}
